import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import {
  AdditionalInformation,
  CurrentResidence,
  CurrentResidenceLang,
  EducationLevel,
  EducationLevelLang,
  MaritalStatus,
  MaritalStatusLang,
} from '../../interfaces';
import { AppStateService } from '../../../app-state.service';

// service
@Injectable({
  providedIn: 'root',
})
export class AdditionalInformationService {
  userInfo: any = [];

  constructor(
    private httpClient: HttpClient,
    private appStateService: AppStateService
  ) {}

  getEducation(lang: string): Promise<EducationLevel[]> {
    return this.httpClient
      .get<EducationLevelLang[]>(`assets/data/lookup/education-level.json`)
      .toPromise()
      .then((response: any) => {
        return response?.education?.[lang];
      })
      .catch((error) => {
        this.handleError(error);
        return [];
      });
  }

  getCurrentResidence(lang: string): Promise<CurrentResidence[]> {
    return this.httpClient
      .get<CurrentResidenceLang[]>(`assets/data/lookup/current-residence.json`)
      .toPromise()
      .then((response: any) => {
        return response?.currentResidenceList?.[lang];
      })
      .catch((error) => {
        this.handleError(error);
        return [];
      });
  }

  getMaritalStatus(lang: string): Promise<MaritalStatus[]> {
    return this.httpClient
      .get<MaritalStatusLang[]>(`assets/data/lookup/marital-status.json`)
      .toPromise()
      .then((response: any) => {
        return response?.marital?.[lang];
      })
      .catch((error) => {
        this.handleError(error);
        return [];
      });
  }

  submitAdditionalInformation(
    data: AdditionalInformation
  ): Observable<AdditionalInformation> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    // return this.httpClient.post<AdditionalInformation>(
    //   `${environment.apiBaseUrl}/v1/dgl-applications/save`,
    //   data,
    //   httpOptions
    // );

    return this.httpClient.post<AdditionalInformation>(
      `assets/data/personal/submit-additional-information.json`,
      data,
      httpOptions
    );
  }

  getStateSalary(): any {
    const state = this.appStateService.snapshot.loanApplication;
    if (state) {
      return state.salary;
    }
    return null;
  }

  getStateAddtionalInformation(): any {
    return this.appStateService.snapshot.additionalInformation;
  }

  clickNext(additionalInformation: AdditionalInformation) {
    this.appStateService.updateStateAdditionalInformation(
      additionalInformation
    );
  }

  private handleError(error: HttpErrorResponse): any {
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
    // Return an observable with a user-facing error message.
    return throwError('Something bad happened; please try again later.');
  }
}
